(function () {
  'use strict';

  function initialiseSmartBellsSelector(section) {
    if (!section || section.dataset.smartbellsInitialised === 'true') {
      return;
    }

    var dataScript = section.querySelector('[data-smartbells-data]');

    if (!dataScript) {
      return;
    }

    var config;

    try {
      config = JSON.parse(dataScript.textContent);
    } catch (error) {
      console.warn('SmartBells selector: invalid JSON', error);
      return;
    }

    section.dataset.smartbellsInitialised = 'true';

    var state = {
      weight: config.defaultWeight || '415',
      finish: config.defaultFinish || 'chrome'
    };

    var imageEl = section.querySelector('.smartbells-selector__image');
    var bulletsEl = section.querySelector('[data-smartbells-bullets]');
    var priceEl = section.querySelector('[data-smartbells-price]');
    var buttonEl = section.querySelector('[data-smartbells-button]');
    var weightButtons = section.querySelectorAll('[data-weight]');
    var finishButtons = section.querySelectorAll('[data-finish]');
    var finishGroup = section.querySelector(
      '[data-smartbells-finish-group]'
    );

    function getCurrentOption() {
      if (!config.options || !config.options[state.weight]) {
        return null;
      }

      var weightOptions = config.options[state.weight];

      if (weightOptions.single) {
        return weightOptions.single;
      }

      if (weightOptions[state.finish]) {
        return weightOptions[state.finish];
      }

      /*
       * Fallback to the first available finish if the currently
       * selected finish does not exist for this weight.
       */
      var firstKey = Object.keys(weightOptions)[0];

      if (firstKey) {
        state.finish = firstKey;
        return weightOptions[firstKey];
      }

      return null;
    }

    function updateFinishVisibility(option) {
      if (!finishGroup) {
        return;
      }

      var isSingleFinish =
        option && option.singleFinish === true;

      finishGroup.hidden = isSingleFinish;
      finishGroup.setAttribute(
        'aria-hidden',
        isSingleFinish ? 'true' : 'false'
      );
    }

    function buildLocalizedProductUrl(option) {
      if (!option) {
        return '#';
      }

      if (option.handle && config.rootUrl) {
        var root = config.rootUrl;

        if (root.charAt(root.length - 1) !== '/') {
          root += '/';
        }

        return root + 'products/' + option.handle;
      }

      return option.url || '#';
    }

    function preloadOptionImages() {
      if (!config.options) {
        return;
      }

      Object.keys(config.options).forEach(function (weightKey) {
        var weightOptions = config.options[weightKey];

        Object.keys(weightOptions).forEach(function (finishKey) {
          var option = weightOptions[finishKey];

          if (option && option.image) {
            var image = new Image();
            image.src = option.image;
          }
        });
      });
    }

    function extractBulletsFromDescription(html) {
      var bullets = [];

      if (!html) {
        return bullets;
      }

      var temporaryElement = document.createElement('div');
      temporaryElement.innerHTML = html;

      var items = temporaryElement.querySelectorAll('li');

      items.forEach(function (item) {
        if (bullets.length >= 3) {
          return;
        }

        var text = item.textContent || '';

        text = text.replace(/\s+/g, ' ').trim();

        if (text && text.toLowerCase() !== 'ul') {
          bullets.push(text);
        }
      });

      return bullets;
    }

    function renderBullets(option) {
      if (!bulletsEl) {
        return;
      }

      bulletsEl.innerHTML = '';

      var bullets = extractBulletsFromDescription(
        option.descriptionHtml || ''
      );

      bullets.slice(0, 3).forEach(function (text) {
        var item = document.createElement('li');

        item.textContent = text;
        bulletsEl.appendChild(item);
      });
    }

    function renderActiveStates() {
      weightButtons.forEach(function (button) {
        var isActive =
          button.getAttribute('data-weight') === state.weight;

        button.classList.toggle('is-active', isActive);
        button.setAttribute(
          'aria-checked',
          isActive ? 'true' : 'false'
        );
      });

      finishButtons.forEach(function (button) {
        var isActive =
          button.getAttribute('data-finish') === state.finish;

        button.classList.toggle('is-active', isActive);
        button.setAttribute(
          'aria-checked',
          isActive ? 'true' : 'false'
        );
      });
    }

    function renderImage(option) {
      if (!imageEl) {
        return;
      }

      var nextSource = option.image || '';

      imageEl.setAttribute(
        'alt',
        option.imageAlt || option.title || ''
      );

      if (!nextSource) {
        return;
      }

      if (imageEl.getAttribute('src') === nextSource) {
        return;
      }

      imageEl.classList.add('is-changing');

      var preloadImage = new Image();

      preloadImage.onload = function () {
        imageEl.setAttribute('src', nextSource);
        imageEl.classList.remove('is-changing');
      };

      preloadImage.onerror = function () {
        imageEl.setAttribute('src', nextSource);
        imageEl.classList.remove('is-changing');
      };

      preloadImage.src = nextSource;
    }

    function renderPrice(option) {
      if (!priceEl) {
        return;
      }

      var priceHtml = '';

      if (option.compareAtPriceHtml) {
        priceHtml +=
          '<span class="smartbells-selector__compare-price">' +
          option.compareAtPriceHtml +
          '</span>';
      }

      priceHtml +=
        '<span class="smartbells-selector__actual-price">' +
        (option.priceHtml || '') +
        '</span>';

      priceEl.innerHTML = priceHtml;
    }

    function render() {
      var option = getCurrentOption();

      if (!option) {
        return;
      }

      renderActiveStates();
      updateFinishVisibility(option);
      renderImage(option);
      renderBullets(option);
      renderPrice(option);

      if (buttonEl) {
        buttonEl.setAttribute(
          'href',
          buildLocalizedProductUrl(option)
        );
      }
    }

    weightButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.weight =
          button.getAttribute('data-weight');

        render();
      });
    });

    finishButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.finish =
          button.getAttribute('data-finish');

        render();
      });
    });

    preloadOptionImages();
    render();
  }

  function initialiseAllSmartBellsSelectors(context) {
    var scope = context || document;

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches('.smartbells-selector')
    ) {
      initialiseSmartBellsSelector(scope);
    }

    if (!scope.querySelectorAll) {
      return;
    }

    scope
      .querySelectorAll('.smartbells-selector')
      .forEach(function (section) {
        initialiseSmartBellsSelector(section);
      });
  }

  function startObserver() {
    if (!document.body) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }

          initialiseAllSmartBellsSelectors(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function start() {
    initialiseAllSmartBellsSelectors(document);
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  /*
   * Makes the initializer available for Shopify theme-editor
   * section reloads and other theme events.
   */
  window.initialiseSmartBellsSelectors =
    initialiseAllSmartBellsSelectors;

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialiseAllSmartBellsSelectors(event.target);
    }
  );
})();